module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-05-a821c0f60e65b6cfb9b1157b01e5cae9.jpg";